<template>
  <div>
    <div class="invoice-flow__logo-wrapper">
      <div :style="logoStyles" class="method-options-card-header__icon" />

      <div>{{ $t('muchbetter') }}</div>
    </div>

    <div v-if="isRegistered">
      {{ $t('invoice_flow__user_is_registered') }}
    </div>

    <div v-else>
      <span>{{ $t('invoice_flow__user_is_not_registered') }}</span>
      <a :href="dataToView.signup_url" target="_blank"> {{ $t('invoice_flow__please_sign_up') }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';

export default {
  computed: {
    ...mapState(['flowData', 'paymentInvoiceData', 'paymentInvoiceStatuses']),

    paymentInvoice() {
      return this.paymentInvoiceData.data || {};
    },

    dataToView() {
      /*
       *  @returns {
       *     user_registration_status: boolean,
       *     sign_up_link: string | undefined,
       *     method_name: string,
       *     logo: string
       *  } | {}
       * */
      const { requisites } = cloneDeep(this.flowData.payload);

      let data = {
        user_registration_status: null,
        logo: null,
        signup_url: null,
      };

      if (requisites && typeof requisites === 'object') {
        Object.keys(data).forEach(key => {
          if (key in requisites) {
            data[key] = requisites[key];
          }
        });
      }

      Object.keys(data).forEach(key => {
        if (!data[key]) delete data[key];
      });
      return data;
    },

    isRegistered() {
      return this.dataToView.user_registration_status;
    },

    logoStyles() {
      const logo = (this.dataToView && this.dataToView.logo) || this.getLogoUrl('muchbetter');

      return {
        'min-height': '10em',
        width: '10em',
        'background-image': `url(${logo})`,
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'background-size': 'contain',
        'margin-bottom': '20px',
      };
    },
  },

  methods: {
    getLogoUrl(method) {
      return `https://static.openfintech.io/payment_methods/${method}/logo.svg`;
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-flow__logo-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2em;
}
</style>
